export default "__VITE_ASSET__BmuyDki$__"